import gsap from "gsap";
import AbstractComponent from "./abstract-component";

const LOADER_KEY = "loaderShown";
const ORIGIN = "113 113";

// Ogni scudo parte dalla rotazione del precedente (catena sequenziale).
const FAN_STEPS = [
	{ el: "right", from: 0, to: 90 },
	{ el: "bottom", from: 90, to: 180 },
	{ el: "left", from: 180, to: 270 },
];

const FAN_DURATION = 1.35;
const FAN_STOP_EASE = "power4.out"; // decelerazione forte = sensazione di "arrivo"
const FAN_HOLD = 0.28; // pausa tra uno scudo e il successivo

export default class Loader extends AbstractComponent {
	constructor(el) {
		super(el);
		this.DOM = {
			loader: this.$el,
			top: this.$el.querySelector(".js-loader-shield-top"),
			right: this.$el.querySelector(".js-loader-shield-right"),
			bottom: this.$el.querySelector(".js-loader-shield-bottom"),
			left: this.$el.querySelector(".js-loader-shield-left"),
		};

		this.run();
	}

	shouldPlay() {
		try {
			return !sessionStorage.getItem(LOADER_KEY);
		} catch (e) {
			return true;
		}
	}

	markPlayed() {
		try {
			sessionStorage.setItem(LOADER_KEY, "true");
		} catch (e) {}
	}

	hide() {
		document.documentElement.classList.add("has-seen-loader");
		if (this.DOM.loader) {
			this.DOM.loader.style.display = "none";
		}
	}

	run() {
		if (!this.DOM.loader || !this.shouldPlay()) {
			this.hide();
			return;
		}

		const { top, loader } = this.DOM;

		// Scudi del ventaglio : posizione iniziale = rotazione del precedente
		FAN_STEPS.forEach(({ el, from }) => {
			gsap.set(this.DOM[el], {
				rotation: from,
				svgOrigin: ORIGIN,
				opacity: 0,
			});
		});

		gsap.set(top, {
			rotation: 0,
			svgOrigin: ORIGIN,
			opacity: 0,
			scale: 0.94,
			transformOrigin: "50% 50%",
		});

		const tl = gsap.timeline({ onComplete: () => this.finish() });

		// 1. Scudo in alto (ancora)
		tl.to(top, {
			opacity: 1,
			scale: 1,
			duration: 0.75,
			ease: "sine.out",
		});

		// 2. Catena sequenziale : ogni scudo parte dal precedente, si ferma, poi il successivo
		FAN_STEPS.forEach(({ el, to }) => {
			tl.to(this.DOM[el], {
				rotation: to,
				opacity: 1,
				duration: FAN_DURATION,
				ease: FAN_STOP_EASE,
			});
			tl.to({}, { duration: FAN_HOLD });
		});

		// 3. Pausa logo completo
		tl.to({}, { duration: 0.6 });

		// 4. Fade out
		tl.to(loader, {
			opacity: 0,
			duration: 0.75,
			ease: "sine.inOut",
		});
	}

	finish() {
		this.markPlayed();
		this.hide();
		document.dispatchEvent(new CustomEvent("meral:loader-complete"));
	}

	destroy() {}
}
